import { render, staticRenderFns } from "./ItsBaseFarm.vue?vue&type=template&id=68599b10&scoped=true&"
import script from "./ItsBaseFarm.vue?vue&type=script&lang=js&"
export * from "./ItsBaseFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68599b10",
  null
  
)

export default component.exports